import React from 'react';
import { ShieldAlert, LogOut } from 'lucide-react';

const GOLD = '#C9A84C';

const panelStyle = {
  backgroundColor: '#111111',
  border: '1px solid rgba(201, 168, 76, 0.25)',
  borderRadius: '1rem',
  padding: '2rem',
  maxWidth: '32rem',
  margin: '0 auto',
  textAlign: 'center',
};

const AdminMfaGate = ({ mfaEnrollmentRequired, needsMfaSignIn, onSignOut }) => (
  <div
    style={{
      backgroundColor: '#090909',
      minHeight: '60vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
    }}
  >
    <div style={panelStyle}>
      <ShieldAlert size={48} color={GOLD} style={{ marginBottom: '1rem' }} />
      <h1 style={{ color: '#F5F0E8', fontSize: '1.5rem', marginBottom: '0.75rem' }}>
        Multi-Factor Authentication Required
      </h1>
      {mfaEnrollmentRequired ? (
        <p style={{ color: '#9CA3AF', lineHeight: 1.6, marginBottom: '1.5rem' }}>
          Your account has admin access, but MFA is not enrolled yet. Enable multi-factor
          authentication in Firebase Authentication (SMS or authenticator app), then sign out
          and sign back in before accessing the admin panel.
        </p>
      ) : (
        <p style={{ color: '#9CA3AF', lineHeight: 1.6, marginBottom: '1.5rem' }}>
          Your account has admin access, but this session was not signed in with MFA. Sign out
          and sign back in using your second factor to continue.
        </p>
      )}
      <button
        type="button"
        onClick={onSignOut}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.5rem',
          backgroundColor: GOLD,
          color: '#000',
          border: 'none',
          borderRadius: '9999px',
          padding: '0.75rem 1.5rem',
          fontWeight: 700,
          cursor: 'pointer',
        }}
      >
        <LogOut size={18} />
        Sign Out &amp; Re-authenticate
      </button>
    </div>
  </div>
);

export default AdminMfaGate;
